import * as notificationConstants from './notificationConstants';


/**
 * @param toastMessage {object} Toast message
 * @returns {{payload, type: string}}
 */
export const onToastMessage = toastMessage => {

    return {
        payload: toastMessage,
        type: notificationConstants.ACTION_TOAST_MESSAGE
    };
};


/**
 * @param messageId {string} Toast message id to remove
 * @returns {{payload, type: string}}
 */
export const onRemoveToastMessage = messageId => {

    return {
        payload: messageId,
        type: notificationConstants.ACTION_TOAST_MESSAGE_REMOVE
    };
};
